import React from "react";
import { Button, Checkbox } from "@vitalsource/vstui";
import { createThemedComponent } from "@vitalsource/vstui/themes";
import PropTypes from "prop-types";

const CreateButton = createThemedComponent(Button, {
  Button_borderColor_themePrimary_disabled: "white",
  Button_color_themePrimary_disabled: "white",
  Button_fontWeight_disabled: 500
});

export default class EasyToc extends React.Component {
  state = {};

  componentDidMount() {
    this.title.focus();
  }

  onSubmit = e => {
    e.preventDefault();
    const filteredEntries = this.props.tocEntries.filter(
      el => this.state[el.cfi]
    );
    this.props.onCreateReadings(filteredEntries);
  };

  hasSelections() {
    return Object.keys(this.state).some(k => this.state[k]);
  }

  updateSelection = (key, value) => {
    this.setState({
      [key]: value
    });
  };

  render() {
    return (
      <div className="easy-toc">
        <div className="easy-toc-inner">
          <h3 ref={el => (this.title = el)} tabIndex="-1">
            {i18n.t("assignments.easy-toc-long")}
          </h3>
          <p>{i18n.t("assignments.easy-toc-instrux")}</p>
          <form onSubmit={this.onSubmit}>
            <ul>
              {this.props.tocEntries.map(entry => (
                <li key={entry.cfi}>
                  <Checkbox
                    label={entry.title}
                    checked={!!this.state[entry.cfi]}
                    onChange={e =>
                      this.updateSelection(entry.cfi, e.currentTarget.checked)
                    }
                    disabled={this.props.saving}
                  />
                </li>
              ))}
            </ul>
            <CreateButton
              fullWidth
              size="large"
              type="submit"
              disabled={!this.hasSelections() || this.props.saving}
            >
              {this.props.saving
                ? i18n.t("base.saving") + "..."
                : i18n.t("assignments.create-readings")}
            </CreateButton>
            <div className="easy-toc-cancel">
              <Button
                onClick={this.props.onCancel}
                naked
                color="white"
                disabled={this.props.saving}
              >
                {i18n.t("base.cancel")}
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

EasyToc.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onCreateReadings: PropTypes.func.isRequired,
  saving: PropTypes.bool.isRequired,
  tocEntries: PropTypes.arrayOf(
    PropTypes.shape({
      cfi: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired
    })
  ).isRequired
};
